module.exports = "@media print {\n  .breadcrumb {\n    display: none; } }\n"